import { z } from 'zod/v4';

export const PEM_PRIVATE_KEY_VALIDATION_I18N_KEY = 'configureForm.validation.pemPrivateKey';

const PEM_PRIVATE_KEY_PATTERN =
  /^-----BEGIN ((?:[A-Z0-9]+(?: [A-Z0-9]+)* )?PRIVATE KEY)-----\r?\n([A-Za-z0-9+/=]+(?:\r?\n[A-Za-z0-9+/=]+)*)\r?\n-----END \1-----$/;

export function pemPrivateKeySchema() {
  return z
    .string()
    .trim()
    .superRefine((value, ctx) => {
      if (!PEM_PRIVATE_KEY_PATTERN.test(value)) {
        ctx.addIssue({
          code: 'custom',
          params: { i18n: PEM_PRIVATE_KEY_VALIDATION_I18N_KEY },
        });
      }
    });
}

export type IntegrationSchemaPresentation = {
  input?: 'textarea';
};

export type IntegrationSchemaRegistryEntry = {
  i18n?: string;
  component?: string;
  presentation?: IntegrationSchemaPresentation;
};

export const integrationSchemaRegistry = z.registry<IntegrationSchemaRegistryEntry>();
